// Generated from permissions/admin_permissions.json
export enum Permission {
  ADMIN_APP_READ = 'admin_app:read',
  INTEGRATIONS_READ = 'integrations:read',
  INTEGRATIONS_WRITE = 'integrations:write',
  INVENTORY_READ = 'inventory:read',
  INVENTORY_WRITE = 'inventory:write',
  CONNECTORS_READ = 'connectors:read',
  CONNECTORS_WRITE = 'connectors:write',
  ACCESS_FLOWS_READ = 'access_flows:read',
  ACCESS_FLOWS_WRITE = 'access_flows:write',
  ACCESS_BUNDLES_READ = 'access_bundles:read',
  ACCESS_BUNDLES_WRITE = 'access_bundles:write',
  ACTIVITY_READ = 'activity:read',
  ACTIVITY_WRITE = 'activity:write',
  REPORTS_READ = 'reports:read',
  REPORTS_WRITE = 'reports:write',
  DASHBOARD_READ = 'dashboard:read',
  RIGHT_SIZING_READ = 'right_sizing:read',
  ACCESS_GRAPH_READ = 'access_graph:read',
  ANOMALIES_READ = 'anomalies:read',
  WEBHOOK_READ = 'webhook:read',
  WEBHOOK_WRITE = 'webhook:write',
  JIT_PROTECT_READ = 'jit_protect:read',
  JIT_PROTECT_WRITE = 'jit_protect:write',
  PERSONAL_API_TOKEN_WRITE = 'personal_api_token:write',
  IAM_READ = 'iam:read',
  IAM_WRITE = 'iam:write',
  IDENTITIES_READ = 'identities:read',
  IDENTITIES_WRITE = 'identities:write',
  SESSION_AUDIT_READ = 'session_audit:read',
  SYSLOG_READ = 'syslog:read',
  SETTINGS_READ = 'settings:read',
  SETTINGS_WRITE = 'settings:write',
  REQUEST_ON_BEHALF_WRITE = 'request_on_behalf:write',
  ACCESS_REVOKE_WRITE = 'access_revoke:write',
  NOTIFICATIONS_READ = 'notifications:read',
  NOTIFICATIONS_WRITE = 'notifications:write',
}
